import { IAlertSetting } from '../alerts';
import { makeManagedSourceSetFetch } from './_shared/fetchMakers';
import { normalizeSingleEntity } from './_shared/normalizers';
import { makeAlertSettingsUrl } from './_shared/urlMakers';

export const fetchAlertSettings = makeManagedSourceSetFetch<IAlertSetting[]>(
    makeAlertSettingsUrl,
    normalizeSingleEntity
);
